/* eslint-disable global-require */
import React from 'react';
import { useCustomerInfoWithPrefetch } from '../../shared/CustomerInfo/redux/hooks';
import { Body, Wrapper, ChildrenWrapper, FlashMessageContainerWrapper } from './Core.styles';
import { FlashMessageContainer } from '@pegasus/ui-flashmessages/components/flashmessages';
import { useFlashMessagesWithPrefetch } from 'client/shared/flash-messages/redux/hooks';

interface Props {
    children: React.ReactNode;
}

export const CoreAppsLayout = ({ children }: Props) => {
    const messages = useFlashMessagesWithPrefetch();
    useCustomerInfoWithPrefetch();

    return (
        <>
            <FlashMessageContainerWrapper>
                <FlashMessageContainer messages={messages} />
            </FlashMessageContainerWrapper>
            <Body>
                <Wrapper>
                    <ChildrenWrapper>{children}</ChildrenWrapper>
                </Wrapper>
            </Body>
        </>
    );
};
